import React from 'react';
import { setupHelmet } from './analytics/metadata';
import { CommunicationPreferences } from './CommunicationPreferences';
import { setupAnalytics } from './analytics/common';

function Component() {

  setupHelmet();

  return (
    <>
      <CommunicationPreferences />
    </>
  );
}

export const CommunicationPreferencesHOC = () => {

  function setUp() {
    setupAnalytics();
  }

  React.useEffect(setUp, []);

  return (

    <Component />
  );
};
